import Q15_2 from './Q15_2';

export default Q15_2;
